import RouteWithProps from "./routeWithProps";

export { RouteWithProps };
export default {
  RouteWithProps,
};
